export default __webpack_public_path__ + "static/media/business-model-health-check.b1fcdf06.svg";